export const secureDocUploaderRoutes = [
  'SECURE_DOC_UPLOADER_PAGE'
]

export const isSecureDocUploaderRoute = route => secureDocUploaderRoutes.includes(route)

export const onboardingV1Routes = [
  'ONBOARDING_GETTING_STARTED',
  'ONBOARDING_PERSONAL_INFORMATION',
  'ONBOARDING_IDENTITY_VERIFICATION',
  'ONBOARDING_EMPLOYMENT_DETAILS',
  'ONBOARDING_REVIEW_AND_SUBMIT',
  'ONBOARDING_CONFIRMATION',
]

export const onboardingV2Routes = [
  ...onboardingV1Routes,
  'ONBOARDING_ABOUT_YOU',
  'ONBOARDING_YOUR_ACCOUNTS',
  'ONBOARDING_ACCOUNT_DETAILS',
  'ONBOARDING_JOINT_OWNER',
  'ONBOARDING_ADD_CONTACT',
  'ONBOARDING_EDIT_CONTACT',
  'ONBOARDING_CONTACTS_PAGE',
  'ONBOARDING_EMPLOYER_INFORMATION',
  'ONBOARDING_ADDITIONAL_DETAILS',
]

export const isOnboardingRoute = (route, onlyV1) => {
  if (onlyV1) {
    return onboardingV1Routes.includes(route)
  }
  return onboardingV2Routes.includes(route)
}

export default {
  onboardingV1Routes,
  onboardingV2Routes,
  isOnboardingRoute,
  secureDocUploaderRoutes,
  isSecureDocUploaderRoute,
}



// WEBPACK FOOTER //
// ./src/routing/routes/onboardingRoutes.js